import { Box } from '@mui/system';

function FormLayout({ children, marginT }: JSX.Element | JSX.Element[] | any) {
  return (<>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: marginT
      ? '8px'
      : '25px' }}>
      {children}
    </Box>
  </>);
}

export default FormLayout;